import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import '../../MainStyle.css';
import { Player } from '@lottiefiles/react-lottie-player';
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import Button from "../UI/Button/ui";

function OrderConfirmed() {
  const navigate = useNavigate();

  const [pageConst, setConstants] = useState({
    showHeadSearch: true,
    productName: "",
    productDescription: ""
  });

  const moveToOrderDetails = () => {
    navigate("/myorders", { replace: true });
  };

  return (
    <div className={general.appView}>
      <div className={[general.appChildView, general.hideScrollBar].join(" ")}>
        <div className="v-center flex-d-col min-h-100vh resp-width margin-0-auto">
          <Player src={require("../media/animations/order_confirmed_anim.json")} className="player w-125-p" loop autoplay />
          <h3 className="ft-sz-20 mg-t-10">Order Confirmed!</h3>
          <span className="ft-sz-14 mg-t-5">Thankyou for shopping!</span>

          <br></br>
          <Button
            text="View all orders"
            rounded={true}
            action={{ onClick: () => moveToOrderDetails() }}
          />
        </div>

      </div>
    </div>
  );
}

export default OrderConfirmed;